import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Button'
import { Stack } from 'components/Stack'
import { useTranslation } from 'hooks/useTranslation'
import { ChangeEvent } from 'react'
import { QuantityInput } from './EditQuantity.styles'

type EditQuantityButtonsProps = {
  size?: ButtonProps['size']
  product: { productId: string; name: string; quantity: number }
  onQuantityChange: (productId: string, quantity: number) => void
}

export const EditQuantity = ({
  size = 'tiny',
  product,
  onQuantityChange,
}: EditQuantityButtonsProps) => {
  const { t } = useTranslation()

  return (
    <Stack alignItems="center">
      <Button
        size={size}
        variant="tertiary"
        aria-label={t('common:remove-product', { name: product.name })}
        disabled={product.quantity < 1}
        onClick={() => onQuantityChange(product.productId, product.quantity - 1)}
        icon="minus"
      />
      <QuantityInput
        min={0}
        size={size}
        value={product.quantity}
        aria-label={t('common:edit-product-quantity', { name: product.name })}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          onQuantityChange(product.productId, Number(e.target.value))
        }
      />
      <Button
        size={size}
        variant="tertiary"
        aria-label={t('common:add-product', { name: product.name })}
        onClick={() => onQuantityChange(product.productId, product.quantity + 1)}
        icon="plus"
      />
    </Stack>
  )
}
